import styled, { keyframes } from 'styled-components'
import loading from './loading.svg?url'
import get from 'lodash/get'

export const LoadingWrap = Component => styled(Component)`
	${props => props.isLoading ? `
	position: relative;
		&:after {
			content: '';
			display: block;
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			background: url(${loading}) no-repeat center, rgba(255, 255, 255, 0.86);
			background-size: 60px auto;
			z-index: 100;
		}` : ''}
`
const progressAnimation = keyframes`
	0%		{width: 5%;}
  10%   {width: 65%;}
  40%		{width: 85%;}
  100%	{width: 97%;}
`
export const LoadingBar = styled.div`
	height: 3px;
	box-shadow: 0 1px 1px 0 rgba(90, 90, 90, 0.2);
	background-color: ${props => props.theme.darkbgColor};
	position: relative;
	:before {
		content: '';
		height: ${props => get(props, 'style.height', '3px')};
		position: absolute;
		background-color: ${props => props.theme.primaryHover};
		animation-name: ${progressAnimation};
		animation-duration: 10s;
		width: 97%;
  }
`

export const useLoading = ({ isLoading }) => isLoading ? `
	position: relative;
	&:after {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: url(${loading}) no-repeat center, rgba(255, 255, 255, 0.86);
		background-size: 60px auto;
		z-index: 100;
	}
` : ``

export const LoadingSpinner = styled.div`
	position: relative;
	width: ${props => props.children ? '100%' : 'unset'};
	height: ${props => props.children ? '100vh' : 'unset'};
	&:before {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: url(${loading}) no-repeat center, rgba(255, 255, 255, 0.86);
		background-size: 60px auto;
		z-index: 100;
	}
`

const stripeAnimation = keyframes`
	0% {
	  background-position: 0 0;
	}
	100% {
	  background-position: 50px 50px;
	}
`

export const StyledProgessBar = styled.div`
	position: relative;
	height: 30px;
	padding: 8px;
	border-radius: 25px;
	background: #ccc;
	box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
	& > span {
		display: block;
    height: 100%;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    background-color: ${({ theme }) => theme?.primaryHover};
    box-shadow: inset 0 2px 9px rgb(255 255 255 / 30%), inset 0 -2px 6px rgb(0 0 0 / 40%);
    position: relative;
    overflow: hidden;
    transition: width 0.5s;
  	& > span {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);
      z-index: 1;
      background-size: 50px 50px;
      animation: ${stripeAnimation} 2s linear infinite;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      overflow: hidden;
  	}
	}
`
